import { useAuth } from './useAuth';

export function useIsAdmin(): boolean {
  const { user } = useAuth();
  return !!user?.app_metadata?.is_admin;
}
